import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Package } from 'lucide-react';
import Header from './components/Header10';
import Footer from './components/Footer10';

const Orders10 = () => {
    const navigate = useNavigate();
    const [filterStatus, setFilterStatus] = useState('all');

    const orders = [
        {
            id: 'STH-001',
            date: '2026-03-10',
            status: 'delivered',
            total: 4990,
            items: [
                { name: 'Handwoven Cotton Saree', quantity: 1, image: 'https://images.pexels.com/photos/2916387/pexels-photo-2916387.jpeg?auto=compress&cs=tinysrgb&w=200' },
            ],
        },
        {
            id: 'STH-002',
            date: '2026-03-15',
            status: 'shipped',
            total: 3490,
            items: [
                { name: 'Linen Kurta Set', quantity: 1, image: 'https://images.pexels.com/photos/3224610/pexels-photo-3224610.jpeg?auto=compress&cs=tinysrgb&w=200' },
            ],
        },
        {
            id: 'STH-003',
            date: '2026-03-18',
            status: 'processing',
            total: 5490,
            items: [
                { name: 'Chanderi Anarkali', quantity: 1, image: 'https://images.pexels.com/photos/4614070/pexels-photo-4614070.jpeg?auto=compress&cs=tinysrgb&w=200' },
            ],
        },
    ];

    const statusLabels = {
        processing: 'Processing',
        shipped: 'Shipped',
        delivered: 'Delivered',
    };

    const filteredOrders = filterStatus === 'all'
        ? orders
        : orders.filter(o => o.status === filterStatus);

    return (
        <>
            <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&display=swap" rel="stylesheet" />

            <div style={{ fontFamily: "'Inter', sans-serif" }} className="min-h-screen bg-white">
                <Header />

                <main className="pt-16 md:pt-[72px]">
                    {/* Page Header */}
                    <div className="py-10 md:py-16 px-5 md:px-8 text-center" style={{ borderBottom: '1px solid #E7E5E4' }}>
                        <h1 className="text-2xl md:text-3xl font-light text-[#1C1917] tracking-tight">Your Orders</h1>
                    </div>

                    <div className="max-w-[800px] mx-auto px-5 md:px-8 py-8 md:py-12">
                        {/* Filter */}
                        <div className="flex gap-4 mb-8 overflow-x-auto scrollbar-hide">
                            {['all', 'processing', 'shipped', 'delivered'].map((status) => (
                                <button
                                    key={status}
                                    onClick={() => setFilterStatus(status)}
                                    className={`flex-shrink-0 text-xs font-light tracking-wider uppercase transition-all duration-300 bg-transparent cursor-pointer pb-1 ${
                                        filterStatus === status
                                            ? 'text-[#1C1917]'
                                            : 'text-[#A8A29E] hover:text-[#78716C]'
                                    }`}
                                    style={{
                                        border: 'none',
                                        borderBottom: filterStatus === status ? '1px solid #1C1917' : '1px solid transparent',
                                    }}
                                >
                                    {status === 'all' ? 'All Orders' : statusLabels[status]}
                                </button>
                            ))}
                        </div>

                        {/* Orders List */}
                        {filteredOrders.length === 0 ? (
                            <div className="text-center py-20">
                                <Package className="w-8 h-8 text-[#D6D3D1] mx-auto mb-4" strokeWidth={1} />
                                <p className="text-[#78716C] text-sm font-light mb-4">No orders found</p>
                                <button
                                    onClick={() => navigate('/template10/shop')}
                                    className="text-[#78716C] text-xs tracking-[2px] uppercase font-normal hover:text-[#1C1917] transition-colors bg-transparent border-none cursor-pointer underline underline-offset-4"
                                >
                                    Start Shopping
                                </button>
                            </div>
                        ) : (
                            <div className="space-y-0">
                                {filteredOrders.map((order) => (
                                    <div
                                        key={order.id}
                                        className="py-6"
                                        style={{ borderBottom: '1px solid #E7E5E4' }}
                                    >
                                        {/* Order Header */}
                                        <div className="flex justify-between items-start mb-4">
                                            <div>
                                                <p className="text-[#1C1917] text-sm font-normal">{order.id}</p>
                                                <p className="text-[#A8A29E] text-xs font-light mt-1">
                                                    {new Date(order.date).toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' })}
                                                </p>
                                            </div>
                                            <div className="text-right">
                                                <p className="text-[#1C1917] text-sm font-light">
                                                    ₹{order.total.toLocaleString('en-IN')}
                                                </p>
                                                <p className="text-[#78716C] text-xs font-light mt-1 capitalize">
                                                    {statusLabels[order.status]}
                                                </p>
                                            </div>
                                        </div>

                                        {/* Items */}
                                        {order.items.map((item, index) => (
                                            <div key={index} className="flex gap-4 mt-3">
                                                <div className="w-14 h-18 overflow-hidden bg-[#FAFAF9] flex-shrink-0">
                                                    <img
                                                        src={item.image}
                                                        alt={item.name}
                                                        className="w-full h-full object-cover"
                                                    />
                                                </div>
                                                <div>
                                                    <p className="text-[#1C1917] text-sm font-light">{item.name}</p>
                                                    <p className="text-[#A8A29E] text-xs font-light">Qty: {item.quantity}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </main>

                <Footer />
            </div>
        </>
    );
};

export default Orders10;
